import React, { Component } from "react";

class SliderHorizontal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMoving: false,
      disabled: false,
      dataCount: 0
    };
  }
  map = (num, in_min, in_max, out_min, out_max) => {
    return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  };

  createLabels = (data, selected) => {
    let offset = 290;
    let fontSize = data.length > 30 ? "5px" : "10px";

    return data.map((label, index) => {
      return (
        <div
          className="holder-label-horizontal"
          key={index}
          style={{
            left: `calc(${this.map(
              index,
              0,
              data.length - 1,
              0,
              100
            )}% - 40px)`,
            fontSize: fontSize
          }}
        >
          {selected === index ? (
            <strong
              ref="tagName"
              style={{
                fontSize: `14px`,
                backgroundColor: "white",
                position: "relative",
                zIndex: 99
              }}
            >
              {label}
            </strong>
          ) : (
            label
          )}
        </div>
      );
    });
  };

  handleOnChange = ({ target }) => {
    if (this.props.disabled) return;
    let selectedId = Number(target.value);
    this.props.onChange(
      this.props.name,
      this.props.data[selectedId],
      selectedId
    );
  };

  render() {
    let { data, unit, selectedId } = this.props;
    let { disabled } = this.state;

    return (
      <div className="slider-horizontal-container">
        <span className="label">{this.props.label}</span>
        <div className="slider-horizontal-dot" ref="slider">
          {this.createLabels(data, selectedId)}
        </div>
        <input
          type="range"
          className="slider-horizontal"
          min={0}
          value={selectedId}
          onChange={this.handleOnChange}
          max={data.length - 1}
          disabled={disabled}
        />
        <span className="unit">{unit}</span>
      </div>
    );
  }
}

export default SliderHorizontal;
